<template>
  <div>
    <table class="table table-striped table-bordered table-hover">
      <thead>
        <tr>
          <th>Nome</th>
          <th>Data Início</th>
          <th>Data Fim</th>
          <th>Horário</th>
          <th>Motivo</th>
          <th>Observação</th>
          <th>Situação</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="bloqueio in bloqueios" :key="bloqueio._id">
          <td>{{ bloqueio.usuario.name }}</td>
          <td>{{ formatarData(bloqueio.dataInicio, 'DD/MM/YYYY') }}</td>
          <td>{{ formatarData(bloqueio.dataFim, 'DD/MM/YYYY') }}</td>
          <td>{{ bloqueio.horarioInicio }} - {{ bloqueio.horarioFim }}</td>
          <td>{{ bloqueio.motivo }}</td>
          <td>{{ bloqueio.observacao }}</td>
          <td :class="bloqueio.ativo ? 'text-success' : 'text-danger'">{{
            bloqueio.ativo ? 'Ativo' : 'Cancelado'
          }}</td>
          <td>
            <RouterLink
              v-tooltip="'Editar'"
              data-test-id="link-auto-1"
              :to="'/usuario/bloqueio/cadastro/' + bloqueio._id"
              role="button"
              class="btn btn-xs btn-link"
            >
              <span class="fa fa-edit" />
            </RouterLink>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import * as formatadores from '@/utils/formatadores'

export default {
  name: 'BloqueioTabela',
  props: {
    bloqueios: {
      type: Array,
      required: true,
    },
  },
  methods: {
    ...formatadores,
  },
}
</script>
